import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=11bcaabe"
import script from "./loading-spinner.ts?vue&type=script&lang=ts&external"
export * from "./loading-spinner.ts?vue&type=script&lang=ts&external"
import style0 from "./loading-spinner.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11bcaabe')) {
      api.createRecord('11bcaabe', component.options)
    } else {
      api.reload('11bcaabe', component.options)
    }
    module.hot.accept("./loading-spinner.vue?vue&type=template&id=11bcaabe", function () {
      api.rerender('11bcaabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-spinner/loading-spinner.vue"
export default component.exports